import React from 'react';

const IntroPlacaTipoMarmol = () => {
  return (
    <section id="placas-tradicionales" className="about-service pb-0">
      <div className="container">
        <div className="row align-items-center mt-n1-9">
          <div className="col-lg-6 mt-1-9">
            <div className="pe-lg-6 pe-xl-15">
              <div className="title-style2 mb-2-2 wow fadeIn" data-wow-delay="200ms">
                <h2 className="h1">Placa Tipo Mármol Rígida de PVC</h2>
              </div>
              <p className="text-secondary text-uppercase font-weight-800 mb-1-9">
              Elegancia y funcionalidad en un solo material
              </p>
              <p className="mb-2-9">
              Descubre la solución perfecta para revestir tus espacios con estilo y practicidad. Las placas tipo mármol de PVC combinan la sofisticación del mármol natural 
              con las ventajas de los materiales sintéticos, ofreciendo una alternativa moderna, duradera y económica para arquitectos y diseñadores exigentes.
              </p>
            </div>
          </div>
          <div className="col-lg-6 mt-1-9">
            <div>
              <div className="row align-items-center">
                <div className="col-6">
                  <div>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-placa-tipo-marmol/placa-tipo-marmol-intro-der.jpg`} alt="placa tipo mármol bodega" className="rounded" />
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <img src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-placa-tipo-marmol/placa-tipo-marmol-intro-izq.jpg`} alt="placa tipo mármol bodega" className="mb-sm-4 rounded" />
                    <div className="bg-dark p-1-6 p-md-1-9 d-none d-sm-block rounded">
                      <h5 className="mb-0 text-white">Exclusivo para Interiores</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroPlacaTipoMarmol;